import { lazy } from 'react';

const SignUpPage = lazy(() => import('./pages/SignUpPage'));

export const SignUpEntry = () => <SignUpPage />;
